import CloseIcon from "@mui/icons-material/Close";
import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import "../../CSS/app.min.css";
import "../../CSS/bootstrap.min.css";
import "../../CSS/custom.min.css";
import "../../CSS/mermaid.min.css";
import "../../CSS/slickDashboard.css";
import welcomeImg from "../../Images/welcomeImg.jpg";
import {
	showLoador,
	showNotification,
} from "../../Pages/Landing/Landing.slice";
import { getNoticeMsgByUserType } from "../../Slice/noticeMsg.slice";
import { imageUrl } from "../../config/Url";
import endpoint from "../../config/endpoints";
import { serverMsg } from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import SystemInterruptionAlert from "./PaymentValidationPopUp";
import { primary } from "../../config/ColorObj";
import { logOut } from "../Login/login.slice";
import { compose } from "recompose";
import { withRouter } from "../../components/withRouter";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": {
		padding: theme.spacing(2),
	},
	"& .MuiDialogActions-root": {
		padding: theme.spacing(1),
	},
}));
const BootstrapDialogTitle = (props) => {
	const { classes, children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

class WelcomePage extends Component {
	state = {
		noticeMspPopUp: true,
		licensePopUp: true,
		formStatus: "",
		paymentObject: {},
		openPaymentValidation: false,
	};

	async componentDidMount() {
		const { getNoticeMsgByUserType, showLoador, showNotification } = this.props;

		const isNewDomainApplicable =
			localStorage.getItem("isNewDomainApplicable") ?? 0;

		if (isNewDomainApplicable == 1) {
			showLoador({ loador: true });
			await apiGet({
				url: endpoint.logOut,
			}).then(({ data, success }) => {
				if (success) {
					localStorage.clear();
					logOut();
					window.location.reload(true);
					window.location.replace("/login");
				}
				showLoador({ loador: false });
			});
		}

		await apiGet({
			url: "/api/distributiondevelop/v1/payment-recovery-master",
		}).then((response) => {
			if (response) {
				this.setState({
					paymentObject: response.data.data ? response.data.data : {},
					openPaymentValidation: response.data?.data?.stageIndex !== 0,
				});
				localStorage.setItem(
					"paymentValidationMsg",
					response.data.data.description2,
				);
				localStorage.setItem(
					"showPaymentValidationMsg",
					response.data.data.stageIndex,
				);
				localStorage.setItem("marueeData", JSON.stringify(response.data.data));
			}
		});

		const userTypeIdFlag =
			localStorage.getItem("userTypeId") == 1
				? false
				: localStorage.getItem("userTypeId") == 6
					? false
					: true;
		const noticeMsgListDataList = localStorage.getItem("noticeMsgListData");
		const noticeMsgListDataLocalStorage = JSON.parse(noticeMsgListDataList);

		const licensetDataLocalStorage = localStorage.getItem("licenseData");

		if (userTypeIdFlag) {
			if (!noticeMsgListDataLocalStorage) {
				showLoador({ loador: true });
				await getNoticeMsgByUserType().then(({ response, success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					} else {
						const noticeMsgList = response.length !== 0 ? response : [];
						localStorage.setItem(
							"noticeMsgListData",
							JSON.stringify(noticeMsgList),
						);

						this.setState({
							noticeMspPopUp: true,
						});
					}
				});
			}

			if (!licensetDataLocalStorage) {
				showLoador({ loador: true });
				apiGet({
					url: endpoint.stackholder + "/check-license-expiration",
				}).then((data) => {
					showLoador({ loador: false });
					if (
						data &&
						data.data &&
						data.data.data &&
						Object.keys(data.data.data).length !== 0
					) {
						if (data.data.data.error) {
							let status = data.data.data.message;
							localStorage.setItem("licenseData", status);
							this.setState({
								formStatus: status,
								licensePopUp: true,
							});
						}
					}
				});
			}
		}
	}

	handleClose = () => {
		this.setState({
			noticeMspPopUp: false,
		});
	};

	handleCloseForLicense = () => {
		this.setState({
			licensePopUp: false,
		});
	};

	handleClosePopup = () => {
		this.setState({
			openPaymentValidation: false,
		});
	};

	render() {
		const { noticeList } = this.props;
		const {
			noticeMspPopUp,
			licensePopUp,
			formStatus,
			openPaymentValidation,
			paymentObject,
		} = this.state;
		const userTypeIdFlag =
			localStorage.getItem("userTypeId") == 1
				? false
				: localStorage.getItem("userTypeId") == 6
					? false
					: true;
		const noticeMsgListDataList = localStorage.getItem("noticeMsgListData");
		const noticeMsgListDataLocalStorage = JSON.parse(noticeMsgListDataList);

		const licensetDataLocalStorage = localStorage.getItem("licenseData");

		const companyLogo = localStorage.getItem("companyLogo");

		const isNewDomainApplicable =
			localStorage.getItem("isNewDomainApplicable") ?? 0;

		return (
			<div style={{ width: "100%", position: "relative", height: "100%" }}>
				{openPaymentValidation && (
					<SystemInterruptionAlert
						paymentObject={paymentObject}
						onClose={this.handleClosePopup}
					/>
				)}
				<img style={{ width: "100%", height: "100%" }} src={welcomeImg} />
				<div
					style={{
						position: "absolute",
						display: "flex",
						flexDirection: "column",
						top: "1%",
						left: "1%",
						color: primary,
					}}
				>
					{" "}
					<span>Welcome,</span>{" "}
					<span style={{ fontSize: "1.5rem", fontWeight: "600" }}>
						{" "}
						{localStorage.getItem("firmName")}
					</span>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between  ",
						position: "absolute",
						alignItems: "center",
						top: "26%",
						width: "100%",
						left: "0",
						gap: "0",
					}}
				>
					<din
						style={{
							width: "50%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<img
							style={{
								height: "32%",
								width: "30rem",
							}}
							src={imageUrl + companyLogo}
						/>
					</din>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "50%",
						}}
					>
						<div
							style={{
								fontFamily: "roboto",
								fontSize: "100px",
								color: "white",
								textOverflow: "-moz-initial",
								fontWeight: "700",
							}}
						>
							Welcome to
						</div>
						<span
							style={{
								fontFamily: "roboto",
								fontSize: "140px",
								color: "white",
								lineHeight: "90%",
								fontWeight: "700",
							}}
						>
							DMS{" "}
						</span>
					</div>
				</div>
				{userTypeIdFlag &&
					noticeMspPopUp &&
					(noticeMsgListDataLocalStorage
						? noticeMsgListDataLocalStorage
						: noticeList.noticeMsg
					).length !== 0 && (
						<BootstrapDialog
							// onClose={this.handleClose}
							aria-labelledby="customized-dialog-title"
							open={true}
							fullWidth
							maxWidth="md"
						>
							<BootstrapDialogTitle
								id="customized-dialog-title"
								onClose={isNewDomainApplicable == 1 ? null : this.handleClose}
							>
								Notification -{" "}
								{
									(noticeMsgListDataLocalStorage
										? noticeMsgListDataLocalStorage
										: noticeList.noticeMsg
									).length
								}
							</BootstrapDialogTitle>
							<DialogContent dividers>
								{(noticeMsgListDataLocalStorage
									? noticeMsgListDataLocalStorage
									: noticeList.noticeMsg
								).map((noticeObject, index) => (
									<React.Fragment key={index}>
										<Grid
											item
											sm={12}
											xs={12}
											md={12}
											lg={12}
											container
											justifyContent="center"
										>
											{" "}
											<img
												className="Image14"
												style={{ width: 810, height: 700 }}
												src={imageUrl + noticeObject.image}
												alt={noticeObject.noticeHeadline}
											/>
										</Grid>
										<br />
										<Grid
											item
											sm={12}
											xs={12}
											md={12}
											lg={12}
											container
											justifyContent="center"
										>
											<div style={{ fontSize: "large", fontWeight: "550" }}>
												{noticeObject.noticeHeadline}
											</div>
										</Grid>
										<br />
										<Grid
											item
											sm={12}
											xs={12}
											md={12}
											lg={12}
											container
											justifyContent="left"
										>
											<div style={{ fontSize: "small" }}>
												{noticeObject.description}
											</div>
										</Grid>
										<br />
									</React.Fragment>
								))}
							</DialogContent>
						</BootstrapDialog>
					)}
				{userTypeIdFlag &&
					licensePopUp &&
					(licensetDataLocalStorage
						? licensetDataLocalStorage
						: formStatus) && (
						<>
							<BootstrapDialog
								// onClose={this.handleCloseForLicense}
								aria-labelledby="customized-dialog-title"
								open={true}
								fullWidth
								maxWidth="md"
							>
								<BootstrapDialogTitle
									id="customized-dialog-title"
									onClose={this.handleCloseForLicense}
								>
									License
								</BootstrapDialogTitle>
								<DialogContent dividers>
									<>
										<Grid
											item
											sm={12}
											xs={12}
											md={12}
											lg={12}
											container
											justifyContent="center"
										>
											<div style={{ fontSize: "large" }}>
												{licensetDataLocalStorage
													? licensetDataLocalStorage
													: formStatus}
											</div>
										</Grid>
										<br />
									</>
								</DialogContent>
							</BootstrapDialog>
						</>
					)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	noticeList: state.noticeMsg,
});

const mapDispatchToProps = {
	showLoador,
	showNotification,
	getNoticeMsgByUserType,
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(WelcomePage);
